import React from "react";
import tw from "twin.macro";
// styled-components is not strictly necessary for just styling an iframe,
// but we'll use `tw` directly on the element which is the standard approach with twin.macro.

// Styled iframe component using twin.macro
const MapIframe = tw.iframe`
  w-full
  h-[450px]
  border-0
  block
`;

const MapSection = () => {
  // ** IMPORTANT: Replace this URL with your actual Google Maps Embed URL **
  // You can get this from Google Maps -> Share -> Embed a map.
  // The URL typically starts with https://www.google.com/maps/embed?...
  const defaultMapEmbedUrl =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7280816174634!2d32.513328411394966!3d0.3853526639132909!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177daf00589da0a5%3A0x8bc11aa6b5dbffd3!2sNANSANA%20HEIGHTS!5e0!3m2!1sen!2sug!4v1747674795498!5m2!1sen!2sug";

  return (
    // Use a semantic HTML5 section tag if appropriate for your page structure
    <section>
      <MapIframe
        src={defaultMapEmbedUrl}
        allowFullScreen="" // Allow full screen mode
        loading="lazy" // Lazy load the iframe for performance
        referrerPolicy="no-referrer-when-downgrade" // Security best practice
        // width="600" height="450" // These attributes are overridden by tw`w-full h-[300px]`
      ></MapIframe>
    </section>
  );
};

export default MapSection;

<iframe
  width="600"
  height="450"
  style="border:0;"
  allowfullscreen=""
  //   loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
></iframe>;
